export const resources = {
    en: {
        translation: {
            common: {
                cancel: 'Cancel',
                close: 'Close',
                saveChanges: 'Save changes',
                saved: 'Saved!',
                light: 'Light',
                dark: 'Dark',
                errorOccurred: 'An error occurred',
                networkError: 'Network error. Check your connection.',
            },
            profile: {
                title: 'Profile Settings',
                tab: {
                    profile: 'Profile',
                    security: 'Security',
                    preferences: 'Preferences',
                },
                activation: {
                    active: 'Activated',
                    inactive: 'Not Activated',
                },
                stats: 'Notes: {{total}} · Shared: {{shared}}',
                fields: {
                    fullName: 'Full Name',
                    login: 'Login',
                    email: 'Email',
                    emailHint: 'Email cannot be changed',
                    bio: 'Bio',
                    loginPlaceholder: 'Your username',
                    bioPlaceholder: 'A few words about yourself',
                },
                security: {
                    changePassword: 'Change Password',
                    currentPassword: 'Current password',
                    newPassword: 'New password',
                    confirmPassword: 'Confirm new password',
                    updatePassword: 'Update password',
                    twoFactor: 'Two-Factor Authentication',
                    soon: 'Soon',
                    comingSoon: 'Coming soon',
                },
                preferences: {
                    theme: 'Theme',
                    accent: 'Accent Color',
                    language: 'Language',
                    editorShortcuts: 'Editor Shortcuts',
                    resetShortcuts: 'Reset to defaults',
                    pressKeyCombo: 'Press a key combo…',
                },
                actions: {
                    profileUpdated: 'Profile updated',
                    profileUpdateFailed: 'Failed to update profile',
                    passwordFillAll: 'Fill in all password fields',
                    passwordMismatch: 'Passwords do not match',
                    passwordUpdated: 'Password updated',
                    passwordUpdateFailed: 'Failed to change password',
                },
                shortcuts: {
                    duplicateLine: 'Duplicate paragraph',
                    deleteLine: 'Delete paragraph',
                    moveParagraphUp: 'Move paragraph up',
                    moveParagraphDown: 'Move paragraph down',
                    insertHR: 'Insert horizontal rule',
                },
            },
            inlineAi: {
                actions: {
                    fix: 'Fix',
                    shorten: 'Shorten',
                    simplify: 'Simplify',
                    structure: 'Structure',
                    toRu: 'To RU',
                    toEn: 'To EN',
                    continueText: 'Continue',
                },
                generating: 'Generating…',
                replace: 'Replace',
                insertAfter: 'Insert after',
                back: 'Back',
                close: 'Close',
                requestFailed: 'Request failed',
            },
            auth: {
                switchThemeDark: 'Switch to dark mode',
                switchThemeLight: 'Switch to light mode',
                login: {
                    title: 'Sign in',
                    description: 'Sign in to your account',
                    emailOrUsername: 'Email or username',
                    password: 'Password',
                    forgotPassword: 'Forgot password?',
                    rememberMe: 'Remember me',
                    submit: 'Sign in',
                    submitting: 'Signing in...',
                    needAccount: 'Need an account?',
                    register: 'Register',
                    invalidCredentials: 'Invalid email/username or password',
                    success: 'Signed in successfully',
                },
                register: {
                    title: 'Register',
                    description: 'Create your account',
                    username: 'Username',
                    email: 'Email',
                    password: 'Password',
                    confirmPassword: 'Confirm password',
                    submit: 'Register',
                    submitting: 'Registering...',
                    hasAccount: 'Already have an account?',
                    login: 'Sign in',
                    success: 'Registration completed successfully',
                    failed: 'Registration failed',
                },
                fillAllFields: 'Fill in all fields',
                passwordMismatch: 'Passwords do not match',
                minPassword: 'Password must contain at least 3 characters',
                forgotPassword: {
                    title: 'Password recovery',
                    description:
                        'Enter the email you used when registering. We will send password recovery instructions.',
                    emailLabel: 'Email',
                    emailPlaceholder: 'example@email.com',
                    enterEmail: 'Enter email',
                    emailSent: 'Password recovery instructions have been sent to your email',
                    requestFailed: 'Failed to send request',
                    successTitle: 'Check your inbox',
                    successText: 'We sent password recovery instructions to {{email}}',
                    spamHint:
                        'If you did not receive the email, check your spam folder or try again in a few minutes.',
                    submitting: 'Sending...',
                    submit: 'Send',
                    closeAria: 'Close',
                },
            },
            resetPassword: {
                validatingToken: 'Validating token...',
                invalidTokenTitle: 'Invalid token',
                invalidTokenText:
                    'The password reset link is invalid or expired. Please request a new link.',
                backHome: 'Back to home',
                successTitle: 'Password updated',
                successText: 'Your password has been updated. Redirecting to sign in...',
                title: 'Reset password',
                description: 'Enter a new password for your account',
                newPassword: 'New password',
                confirmPassword: 'Confirm password',
                submit: 'Reset password',
                submitting: 'Resetting password...',
                cancel: 'Cancel',
                tokenNotFound: 'Token not found',
                requestFailed: 'Password reset failed',
                success: 'Password updated successfully',
                invalidTokenMessage: 'Invalid or expired token',
            },
            activation: {
                tokenMissing: 'Activation token not found',
                loading: 'Activating account...',
                successTitle: 'Account activated!',
                successText: 'Your account has been activated. Redirecting to home...',
                errorTitle: 'Activation error',
                backHome: 'Back to home',
                successToast: 'Account activated successfully!',
                failed: 'Activation failed. Please request a new activation email.',
                requestFailed: 'Account activation failed',
                resendSent: 'Activation email sent to your inbox',
                resendFailed: 'Failed to send email',
                notActivatedYet: 'Account is not activated yet. Check your email.',
                checkStatusFailed: 'Failed to check activation status',
                bannerDescription: 'Confirm your email {{email}} — follow the link in the message.',
                resending: 'Sending...',
                resend: 'Resend',
                checking: 'Checking...',
                checkActivation: 'Check activation',
            },
            landing: {
                themeLight: 'Light theme',
                themeDark: 'Dark theme',
                login: 'Sign in',
                register: 'Register',
                heroTitle: 'Real-time collaborative notes',
                heroDescription:
                    'Create, edit, and share markdown notes. Work with teammates with instant sync.',
                startFree: 'Get started for free',
                publicNotes: 'Public notes',
                featureEditorTitle: 'Markdown editor',
                featureEditorDescription:
                    'Full-featured markdown editor with syntax support, highlighting, and preview.',
                featureCollabTitle: 'Collaboration',
                featureCollabDescription:
                    'Real-time editing: multiple users can edit one document without conflicts.',
                featureAccessTitle: 'Flexible access',
                featureAccessDescription:
                    'Share notes by link and manage read/write permissions.',
                sectionTitle: 'Public notes',
                loading: 'Loading...',
                notesCount: '{{count}} notes',
                searchPlaceholder: 'Search notes...',
                emptySearch: 'Nothing found',
                emptyNotes: 'No public notes yet',
                untitled: 'Untitled',
            },
            home: {
                untitled: 'Untitled',
                noConnection: 'No server connection',
                loadFailed: 'Failed to load notes',
                createNew: 'Create new note',
                newNote: 'New Note',
                loading: 'Loading notes...',
                emptyTitle: 'No notes yet',
                emptyText: 'Create your first note to get started',
                emptyButton: 'Create a note',
                title: 'Your Notes',
                offline: 'offline',
                gridView: 'Grid view',
                listView: 'List view',
                sortEdited: 'Date Edited',
                sortCreated: 'Date Created',
                sortAZ: 'A–Z',
                sortZA: 'Z–A',
                filteredBy: 'Filtered by:',
                clearAll: 'Clear all',
                recent: 'Recent',
                starred: 'Starred',
                sharedWithMe: 'Shared with Me',
                allNotes: 'All Notes',
            },
            userMenu: {
                profile: 'Profile',
                signOut: 'Sign Out',
                userFallback: 'User',
            },
            sidebar: {
                goToProfile: 'Go to profile',
                preferences: 'Preferences',
                tags: 'Tags',
                trash: 'Trash',
                myNotes: 'My Notes',
                shared: 'Shared',
                searchPlaceholder: 'Search...',
                newNote: 'New Note',
                newFolder: 'New Folder',
                newNoteHotkey: 'New Note (Ctrl+N)',
                newFolderTitle: 'New Folder',
                activateForNotes: 'Activate your account to create notes',
                activateForFolders: 'Activate your account to create folders',
                folderRenamed: 'Folder renamed',
                noteRenamed: 'Note renamed',
                folderCreated: 'Folder created',
                noteCreated: 'Note created',
                subnoteCreated: 'Sub-note created',
            },
            topbar: {
                toggleMenu: 'Toggle menu',
                makePrivate: 'Make private',
                makePublic: 'Make public',
                public: 'Public',
                private: 'Private',
                publicNote: 'Public note',
                tags: 'Tags',
                share: 'Share',
                leaveNote: 'Leave this note',
                leave: 'Leave',
                notifications: 'Notifications',
                moderatorDashboard: 'Moderator Dashboard',
                moderator: 'Moderator',
                home: 'Home',
                clickToRename: 'Click to rename',
                ownerProfile: "View {{owner}}'s profile",
                ownerFallback: 'Owner',
                searchAria: 'Search notes (Ctrl+K)',
                searchTrigger: 'Search notes...',
                searchPlaceholder: 'Search notes... (#tag to filter by tag)',
                searchSectionMine: 'My notes',
                searchSectionAll: 'All notes',
                searchSectionPublic: 'Public notes',
                noResults: 'No results for "{{query}}"',
                noNotes: 'No notes yet',
                kbdNavigate: 'navigate',
                kbdOpen: 'open',
                kbdClose: 'close',
                openSidebar: 'Open sidebar',
                closeSidebar: 'Close sidebar',
                dragToTrash: 'Drop here',
                back: 'Back',
                emptyTrash: 'Empty trash',
                emptyTrashConfirmTitle: 'Empty trash',
                emptyTrashConfirmMessage:
                    'All trash items will be permanently deleted. This action cannot be undone.',
                emptyTrashConfirm: 'Empty',
                restore: 'Restore',
                deleteForever: 'Delete forever',
                untitled: 'Untitled',
                trashTitle: 'Trash',
                trashEmpty: 'Trash is empty',
                trashEmptySubtitle: 'Deleted notes and folders will appear here',
                trashHint: 'Notes and folders in trash will be permanently deleted after 30 days.',
                deleteForeverTitle: 'Delete forever',
                deleteForeverConfirm: 'Delete',
                cancel: 'Cancel',
                folderLabel: 'Folder',
                noteLabel: 'Note',
                deleteForeverMessage:
                    '{{type}} "{{title}}" will be deleted permanently.{{extra}}',
                deleteForeverExtra: ' It will also delete {{count}} nested item(s).',
                pinned: 'Pinned',
                confirmPublicTitle: 'Make note public?',
                confirmPublicText:
                    "Anyone with the link will be able to view this note. Make sure it doesn't contain sensitive information.",
                confirmPublicAction: 'Make public',
            },
            editor: {
                words: '{{count}} words',
                minRead: '~{{count}} min read',
                canEdit: 'You can edit',
                autoSaved: 'Auto-saved',
                synced: 'Synced',
                connecting: 'Connecting...',
                offline: 'Offline',
                comments: 'Comments',
                ai: 'AI',
                toc: 'Contents',
                close: 'Close',
                inline: 'Inline',
                general: 'General',
                loading: 'Loading...',
                noInlineComments: 'No inline comments',
                noInlineHint: 'Select text in the editor and click "Comment"',
                noComments: 'No comments',
                writeFirstComment: 'Write the first one',
                resolvedHidden: '{{count}} resolved - hidden',
                send: 'Send (Enter)',
                addComment: 'Add comment...',
                commentFor: 'Comment for "{{text}}"',
                cancelAnchor: 'Cancel',
                noHeadings: 'No headings',
                noHeadingsHint: 'Add headings (# H1, ## H2...) to the document',
                aiSummarize: 'Summarize note',
                aiKeyPoints: 'Key points',
                aiImproveSelection: 'Improve selection',
                aiAskAnything: 'Ask anything about your note',
                aiYou: 'You',
                aiIncludeContext: 'Include note context',
                aiPlaceholder: 'Ask AI... (Enter to send, Shift+Enter for newline)',
                aiStop: 'Stop',
                aiSend: 'Send',
                aiClear: 'Clear conversation',
                aiError: 'Something went wrong',
            },
            notifications: {
                title: 'Notifications',
                markAllRead: 'Mark all read',
                emptyTitle: 'All quiet here',
                emptyText: 'You have no notifications',
                dismiss: 'Dismiss',
                justNow: 'just now',
                minAgo: '{{count}}m ago',
                hourAgo: '{{count}}h ago',
                dayAgo: '{{count}}d ago',
                someone: 'Someone',
                aNote: 'a note',
                untitled: 'Untitled',
                noteShared: '{{actor}} shared "{{title}}" with you ({{perm}})',
                accessRevoked: '{{actor}} revoked your access to "{{title}}"',
                notePublished: '@{{actor}} published a new note "{{title}}"',
                newNotification: 'New notification',
                permEdit: 'edit',
                permView: 'view',
            },
            publicProfile: {
                loading: 'Loading profile...',
                title: 'Public profile',
                notFoundTitle: 'Profile not found',
                notFoundText: 'The user profile you are looking for does not exist or is unavailable.',
                userNotFound: 'User not found',
                loadFailed: 'Failed to load profile',
                loadUserFailed: 'Failed to load user profile',
                notesCount: '{{count}} public notes',
                followersCount: '{{count}} followers',
                unfollowed: 'Unsubscribed from @{{login}}',
                followed: 'Following @{{login}}',
                unfollow: 'Unfollow',
                follow: 'Follow',
                message: 'Message',
                messageNotImplemented: 'Messaging is not implemented yet',
                userPublicNotes: "{{name}}'s public notes",
                sortRecent: 'Most Recent',
                sortPopular: 'Most Popular',
                sortOldest: 'Oldest First',
                noPublicNotes: 'No public notes yet',
                noPublicNotesHint: "{{name}} hasn't shared any notes yet.",
            },
            noteMenu: {
                makePrivate: 'Make private',
                makePublic: 'Make public',
                rename: 'Rename',
                createSubnote: 'Create subnote',
                editTags: 'Edit tags',
                delete: 'Delete',
                pin: 'Pin',
                unpin: 'Unpin',
                createFolder: 'Create folder',
                createNote: 'Create note',
                leaveNote: 'Leave note',
                pinned: 'Note pinned',
                unpinned: 'Note unpinned',
                activateEdit: 'Activate your account to edit notes',
                activateCreateFolders: 'Activate your account to create folders',
                activateCreateNotes: 'Activate your account to create notes',
                activateDelete: 'Activate your account to delete notes',
                leaveNoteConfirm: 'You will lose access to "{{title}}". The owner can add you back.',
                leftNote: 'You left the note',
                activateMakePublic: 'Activate your account to make notes public',
                madePublic: 'Note is now public',
                madePrivate: 'Note is now private',
                noteDeleted: 'Note deleted',
                deleteConfirmTitle: 'Delete note',
                deleteConfirmMessage:
                    'Are you sure you want to delete "{{title}}"? This cannot be undone.',
            },
            share: {
                modalTitle: 'Share "{{title}}"',
                close: 'Close',
                done: 'Done',
                applyToSubnotes: 'Apply to sub-notes',
                inviteByEmail: 'Invite by email',
                invitePlaceholder: 'Enter email or name',
                invite: 'Invite',
                peopleWithAccess: 'People with access',
                you: 'You',
                userFallback: 'User {{id}}',
                permission: {
                    view: 'View',
                    edit: 'Edit',
                    viewOnly: 'View only',
                    viewFull: 'View',
                    editFull: 'Edit',
                },
                link: {
                    title: 'Link access',
                    description: 'The link can be revoked at any time',
                    namePlaceholder: 'Link name (optional)',
                    create: 'Create link',
                    empty: 'No active links',
                    copyTitle: 'Copy',
                    revokeTitle: 'Revoke',
                    expiry: {
                        label: 'Expiry',
                        never: 'Never',
                        oneDay: '1 day',
                        sevenDays: '7 days',
                        thirtyDays: '30 days',
                        noExpiry: 'No expiry',
                        expired: 'Expired',
                        expiresToday: 'Expires today',
                        expiresInDays: 'Expires in {{count}}d',
                    },
                },
                toast: {
                    loadAccessFailed: 'Failed to load access list',
                    activateToInvite: 'Activate your account to invite users',
                    alreadyHasAccess: 'User already has access',
                    activateToManage: 'Activate your account to manage access',
                    cannotRemoveOwner: 'Cannot remove the owner',
                    accessRemoved: 'Access removed',
                    permissionUpdated: 'Access permissions updated',
                    linkCreateFailed: 'Failed to create link',
                    linkRevoked: 'Link revoked',
                    linkDeleteFailed: 'Failed to delete link',
                    linkCopied: 'Link copied',
                    linkCopyFailed: 'Failed to copy',
                    enterEmailOrName: 'Enter email or username',
                    userNotFound: 'User not found',
                    multipleUsers: 'Multiple users found. Refine your search.',
                    userIdFailed: 'Could not resolve user ID',
                    accessGranted: 'Access granted to {{name}}',
                },
                page: {
                    invalidLink: 'Invalid link',
                    linkNotFound: 'Link not found',
                    loadFailed: 'Failed to load link information',
                    loading: 'Loading...',
                    expiredTitle: 'Link expired',
                    expiredDescription:
                        'This link has expired. Ask the owner to create a new one.',
                    invalidDescription: 'This link does not exist or has been revoked.',
                    validUntil: 'Until {{date}}',
                    guestEditHint:
                        'You can view without signing up. Sign in to edit.',
                    openReadOnly: 'Open (read only)',
                    loginToEdit: 'Sign in to edit',
                    guestReadHint: 'You can view this note without signing up.',
                    openHint: 'Click the button below to open the note.',
                    openNote: 'Open note',
                },
            },
            tags: {
                addTags: 'Add tags...',
                removeTag: 'Remove tag',
                createTag: 'Create "{{tag}}"',
                filterByTag: 'Filter by #{{tag}}',
                blockPublicNote: 'Block this public note',
                noContentYet: 'No content yet',
            },
            moderator: {
                noteBlocked: 'Note blocked',
                failedToBlockNote: 'Failed to block note',
                blockPublicNoteTitle: 'Block public note?',
                blockPublicNoteMessage:
                    'Are you sure you want to block "{{title}}"?\n\nThe note will be made private and hidden from public access.',
                block: 'Block',
            },
        },
    },
    ru: {
        translation: {
            common: {
                cancel: 'Отмена',
                close: 'Закрыть',
                saveChanges: 'Сохранить',
                saved: 'Сохранено!',
                light: 'Светлая',
                dark: 'Тёмная',
                errorOccurred: 'Произошла ошибка',
                networkError: 'Ошибка сети. Проверьте подключение к интернету.',
            },
            profile: {
                title: 'Настройки профиля',
                tab: {
                    profile: 'Профиль',
                    security: 'Безопасность',
                    preferences: 'Настройки',
                },
                activation: {
                    active: 'Активирован',
                    inactive: 'Не активирован',
                },
                stats: 'Заметок: {{total}} · Общих: {{shared}}',
                fields: {
                    fullName: 'Полное имя',
                    login: 'Логин',
                    email: 'Email',
                    emailHint: 'Email нельзя изменить',
                    bio: 'О себе',
                    loginPlaceholder: 'Ваш логин',
                    bioPlaceholder: 'Пара слов о себе',
                },
                security: {
                    changePassword: 'Смена пароля',
                    currentPassword: 'Текущий пароль',
                    newPassword: 'Новый пароль',
                    confirmPassword: 'Подтвердите новый пароль',
                    updatePassword: 'Обновить пароль',
                    twoFactor: 'Двухфакторная аутентификация',
                    soon: 'Скоро',
                    comingSoon: 'Скоро будет доступно',
                },
                preferences: {
                    theme: 'Тема',
                    accent: 'Акцентный цвет',
                    language: 'Язык',
                    editorShortcuts: 'Горячие клавиши редактора',
                    resetShortcuts: 'Сбросить по умолчанию',
                    pressKeyCombo: 'Нажмите сочетание…',
                },
                actions: {
                    profileUpdated: 'Профиль обновлён',
                    profileUpdateFailed: 'Не удалось обновить профиль',
                    passwordFillAll: 'Заполните все поля пароля',
                    passwordMismatch: 'Пароли не совпадают',
                    passwordUpdated: 'Пароль обновлён',
                    passwordUpdateFailed: 'Не удалось сменить пароль',
                },
                shortcuts: {
                    duplicateLine: 'Дублировать абзац',
                    deleteLine: 'Удалить абзац',
                    moveParagraphUp: 'Переместить абзац вверх',
                    moveParagraphDown: 'Переместить абзац вниз',
                    insertHR: 'Вставить горизонтальную линию',
                },
            },
            inlineAi: {
                actions: {
                    fix: 'Исправить',
                    shorten: 'Сократить',
                    simplify: 'Упростить',
                    structure: 'Структурировать',
                    toRu: 'На RU',
                    toEn: 'На EN',
                    continueText: 'Продолжить',
                },
                generating: 'Генерация…',
                replace: 'Заменить',
                insertAfter: 'Вставить после',
                back: 'Назад',
                close: 'Закрыть',
                requestFailed: 'Ошибка запроса',
            },
            auth: {
                switchThemeDark: 'Переключить на тёмную тему',
                switchThemeLight: 'Переключить на светлую тему',
                login: {
                    title: 'Вход',
                    description: 'Войдите в свой аккаунт',
                    emailOrUsername: 'Email или имя пользователя',
                    password: 'Пароль',
                    forgotPassword: 'Забыли пароль?',
                    rememberMe: 'Запомнить меня',
                    submit: 'Войти',
                    submitting: 'Вход...',
                    needAccount: 'Нужен аккаунт?',
                    register: 'Зарегистрироваться',
                    invalidCredentials: 'Неверный email/username или пароль',
                    success: 'Вход выполнен успешно',
                },
                register: {
                    title: 'Регистрация',
                    description: 'Создайте свой аккаунт',
                    username: 'Имя пользователя',
                    email: 'Электронная почта',
                    password: 'Пароль',
                    confirmPassword: 'Подтверждение пароля',
                    submit: 'Зарегистрироваться',
                    submitting: 'Регистрация...',
                    hasAccount: 'Уже есть аккаунт?',
                    login: 'Войти',
                    success: 'Регистрация выполнена успешно',
                    failed: 'Ошибка регистрации',
                },
                fillAllFields: 'Заполните все поля',
                passwordMismatch: 'Пароли не совпадают',
                minPassword: 'Пароль должен содержать минимум 3 символа',
                forgotPassword: {
                    title: 'Восстановление пароля',
                    description:
                        'Введите email, который вы использовали при регистрации. Мы отправим вам инструкции по восстановлению пароля.',
                    emailLabel: 'Email',
                    emailPlaceholder: 'example@email.com',
                    enterEmail: 'Введите email',
                    emailSent: 'Инструкции по восстановлению пароля отправлены на ваш email',
                    requestFailed: 'Ошибка при отправке запроса',
                    successTitle: 'Проверьте почту',
                    successText: 'Мы отправили инструкции по восстановлению пароля на адрес {{email}}',
                    spamHint:
                        'Если письмо не пришло, проверьте папку «Спам» или попробуйте ещё раз через несколько минут.',
                    submitting: 'Отправка...',
                    submit: 'Отправить',
                    closeAria: 'Закрыть',
                },
            },
            resetPassword: {
                validatingToken: 'Проверка токена...',
                invalidTokenTitle: 'Токен недействителен',
                invalidTokenText:
                    'Ссылка для сброса пароля недействительна или истекла. Пожалуйста, запросите новую ссылку.',
                backHome: 'Вернуться на главную',
                successTitle: 'Пароль успешно изменен',
                successText: 'Ваш пароль был успешно изменен. Вы будете перенаправлены на страницу входа...',
                title: 'Сброс пароля',
                description: 'Введите новый пароль для вашего аккаунта',
                newPassword: 'Новый пароль',
                confirmPassword: 'Подтверждение пароля',
                submit: 'Сбросить пароль',
                submitting: 'Сброс пароля...',
                cancel: 'Отмена',
                tokenNotFound: 'Токен не найден',
                requestFailed: 'Ошибка при сбросе пароля',
                success: 'Пароль успешно изменен',
                invalidTokenMessage: 'Недействительный или истекший токен',
            },
            activation: {
                tokenMissing: 'Токен активации не найден',
                loading: 'Активация аккаунта...',
                successTitle: 'Аккаунт активирован!',
                successText: 'Ваш аккаунт успешно активирован. Вы будете перенаправлены на главную страницу...',
                errorTitle: 'Ошибка активации',
                backHome: 'Вернуться на главную',
                successToast: 'Аккаунт успешно активирован!',
                failed: 'Активация не удалась. Попробуйте запросить новое письмо.',
                requestFailed: 'Ошибка при активации аккаунта',
                resendSent: 'Письмо с активацией отправлено на ваш email',
                resendFailed: 'Ошибка при отправке письма',
                notActivatedYet: 'Аккаунт ещё не активирован. Проверьте email.',
                checkStatusFailed: 'Ошибка при проверке статуса активации',
                bannerDescription:
                    'Подтвердите email {{email}} — перейдите по ссылке из письма.',
                resending: 'Отправка...',
                resend: 'Отправить повторно',
                checking: 'Проверка...',
                checkActivation: 'Проверить активацию',
            },
            landing: {
                themeLight: 'Светлая тема',
                themeDark: 'Тёмная тема',
                login: 'Войти',
                register: 'Регистрация',
                heroTitle: 'Совместные заметки в реальном времени',
                heroDescription:
                    'Создавайте, редактируйте и делитесь заметками с поддержкой Markdown. Работайте вместе с коллегами - изменения синхронизируются мгновенно.',
                startFree: 'Начать бесплатно',
                publicNotes: 'Публичные заметки',
                featureEditorTitle: 'Markdown-редактор',
                featureEditorDescription:
                    'Полноценный редактор с поддержкой Markdown-синтаксиса, подсветкой и предпросмотром.',
                featureCollabTitle: 'Совместная работа',
                featureCollabDescription:
                    'Реальное время: несколько пользователей редактируют один документ без конфликтов.',
                featureAccessTitle: 'Гибкий доступ',
                featureAccessDescription:
                    'Делитесь заметками по ссылке, управляйте правами чтения и редактирования.',
                sectionTitle: 'Публичные заметки',
                loading: 'Загрузка...',
                notesCount: '{{count}} заметок',
                searchPlaceholder: 'Поиск по заметкам...',
                emptySearch: 'Ничего не найдено',
                emptyNotes: 'Пока нет публичных заметок',
                untitled: 'Без названия',
            },
            home: {
                untitled: 'Без названия',
                noConnection: 'Нет соединения с сервером',
                loadFailed: 'Не удалось загрузить заметки',
                createNew: 'Создать новую заметку',
                newNote: 'Новая заметка',
                loading: 'Загрузка заметок...',
                emptyTitle: 'Пока нет заметок',
                emptyText: 'Создайте первую заметку, чтобы начать работу',
                emptyButton: 'Создать заметку',
                title: 'Ваши заметки',
                offline: 'офлайн',
                gridView: 'Сетка',
                listView: 'Список',
                sortEdited: 'Дата редактирования',
                sortCreated: 'Дата создания',
                sortAZ: 'А-Я',
                sortZA: 'Я-А',
                filteredBy: 'Фильтр по:',
                clearAll: 'Очистить',
                recent: 'Недавние',
                starred: 'Избранные',
                sharedWithMe: 'Поделились со мной',
                allNotes: 'Все заметки',
            },
            userMenu: {
                profile: 'Профиль',
                signOut: 'Выйти',
                userFallback: 'Пользователь',
            },
            sidebar: {
                goToProfile: 'Открыть профиль',
                preferences: 'Настройки',
                tags: 'Теги',
                trash: 'Корзина',
                myNotes: 'Мои заметки',
                shared: 'Общие',
                searchPlaceholder: 'Поиск...',
                newNote: 'Новая заметка',
                newFolder: 'Новая папка',
                newNoteHotkey: 'Новая заметка (Ctrl+N)',
                newFolderTitle: 'Новая папка',
                activateForNotes: 'Активируйте аккаунт, чтобы создавать заметки',
                activateForFolders: 'Активируйте аккаунт, чтобы создавать папки',
                folderRenamed: 'Папка переименована',
                noteRenamed: 'Заметка переименована',
                folderCreated: 'Папка создана',
                noteCreated: 'Заметка создана',
                subnoteCreated: 'Подзаметка создана',
            },
            topbar: {
                toggleMenu: 'Открыть/закрыть меню',
                makePrivate: 'Сделать приватной',
                makePublic: 'Сделать публичной',
                public: 'Публичная',
                private: 'Приватная',
                publicNote: 'Публичная заметка',
                tags: 'Теги',
                share: 'Поделиться',
                leaveNote: 'Покинуть эту заметку',
                leave: 'Покинуть',
                notifications: 'Уведомления',
                moderatorDashboard: 'Панель модератора',
                moderator: 'Модератор',
                home: 'Главная',
                clickToRename: 'Нажмите, чтобы переименовать',
                ownerProfile: 'Открыть профиль {{owner}}',
                ownerFallback: 'Владелец',
                searchAria: 'Поиск по заметкам (Ctrl+K)',
                searchTrigger: 'Поиск по заметкам...',
                searchPlaceholder: 'Поиск по заметкам... (#тег для фильтра)',
                searchSectionMine: 'Мои заметки',
                searchSectionAll: 'Все заметки',
                searchSectionPublic: 'Публичные заметки',
                noResults: 'Ничего не найдено по запросу "{{query}}"',
                noNotes: 'Пока нет заметок',
                kbdNavigate: 'навигация',
                kbdOpen: 'открыть',
                kbdClose: 'закрыть',
                openSidebar: 'Открыть сайдбар',
                closeSidebar: 'Закрыть сайдбар',
                dragToTrash: 'Перетащите сюда',
                back: 'Назад',
                emptyTrash: 'Очистить корзину',
                emptyTrashConfirmTitle: 'Очистить корзину',
                emptyTrashConfirmMessage:
                    'Все элементы корзины будут удалены навсегда. Это действие нельзя отменить.',
                emptyTrashConfirm: 'Очистить',
                restore: 'Восстановить',
                deleteForever: 'Удалить навсегда',
                untitled: 'Без названия',
                trashTitle: 'Корзина',
                trashEmpty: 'Корзина пуста',
                trashEmptySubtitle: 'Удалённые заметки и папки появятся здесь',
                trashHint: 'Заметки и папки в корзине будут удалены навсегда через 30 дней.',
                deleteForeverTitle: 'Удалить навсегда',
                deleteForeverConfirm: 'Удалить',
                cancel: 'Отмена',
                folderLabel: 'Папка',
                noteLabel: 'Заметка',
                deleteForeverMessage:
                    '{{type}} «{{title}}» будет удалена безвозвратно.{{extra}}',
                deleteForeverExtra: ' Вместе с ней будет удалено ещё {{count}} вложенных элементов.',
                pinned: 'Закрепленные',
                confirmPublicTitle: 'Сделать заметку публичной?',
                confirmPublicText:
                    'Любой, у кого есть ссылка, сможет просматривать эту заметку. Убедитесь, что она не содержит чувствительной информации.',
                confirmPublicAction: 'Сделать публичной',
            },
            editor: {
                words: '{{count}} слов',
                minRead: '~{{count}} мин чтения',
                canEdit: 'Вы можете редактировать',
                autoSaved: 'Автосохранение',
                synced: 'Синхронизировано',
                connecting: 'Подключение...',
                offline: 'Офлайн',
                comments: 'Комментарии',
                ai: 'AI',
                toc: 'Содержание',
                close: 'Закрыть',
                inline: 'Inline',
                general: 'Общие',
                loading: 'Загрузка...',
                noInlineComments: 'Нет inline-комментариев',
                noInlineHint: 'Выделите текст в редакторе и нажмите «Комментарий»',
                noComments: 'Нет комментариев',
                writeFirstComment: 'Напишите первый',
                resolvedHidden: '{{count}} решённых — скрыты',
                send: 'Отправить (Enter)',
                addComment: 'Добавить комментарий…',
                commentFor: 'Комментарий к «{{text}}»',
                cancelAnchor: 'Отменить',
                noHeadings: 'Нет заголовков',
                noHeadingsHint: 'Добавьте заголовки (# H1, ## H2…) в документ',
                aiSummarize: 'Кратко о заметке',
                aiKeyPoints: 'Ключевые пункты',
                aiImproveSelection: 'Улучшить выделение',
                aiAskAnything: 'Спросите что угодно по вашей заметке',
                aiYou: 'Вы',
                aiIncludeContext: 'Учитывать контекст заметки',
                aiPlaceholder: 'Спросите AI… (Enter отправить, Shift+Enter новая строка)',
                aiStop: 'Стоп',
                aiSend: 'Отправить',
                aiClear: 'Очистить диалог',
                aiError: 'Что-то пошло не так',
            },
            notifications: {
                title: 'Уведомления',
                markAllRead: 'Прочитать все',
                emptyTitle: 'Пока тихо',
                emptyText: 'У вас нет уведомлений',
                dismiss: 'Скрыть',
                justNow: 'только что',
                minAgo: '{{count}}м назад',
                hourAgo: '{{count}}ч назад',
                dayAgo: '{{count}}д назад',
                someone: 'Кто-то',
                aNote: 'заметка',
                untitled: 'Без названия',
                noteShared: '{{actor}} поделился(ась) с вами "{{title}}" ({{perm}})',
                accessRevoked: '{{actor}} отозвал(а) ваш доступ к "{{title}}"',
                notePublished: '@{{actor}} опубликовал(а) новую заметку "{{title}}"',
                newNotification: 'Новое уведомление',
                permEdit: 'редактирование',
                permView: 'просмотр',
            },
            publicProfile: {
                loading: 'Загрузка профиля...',
                title: 'Публичный профиль',
                notFoundTitle: 'Профиль не найден',
                notFoundText: 'Профиль пользователя не существует или недоступен.',
                userNotFound: 'Пользователь не найден',
                loadFailed: 'Не удалось загрузить профиль',
                loadUserFailed: 'Не удалось загрузить профиль пользователя',
                notesCount: '{{count}} публичных заметок',
                followersCount: '{{count}} подписчиков',
                unfollowed: 'Вы отписались от @{{login}}',
                followed: 'Вы подписались на @{{login}}',
                unfollow: 'Отписаться',
                follow: 'Подписаться',
                message: 'Сообщение',
                messageNotImplemented: 'Сообщения пока не реализованы',
                userPublicNotes: 'Публичные заметки {{name}}',
                sortRecent: 'Сначала новые',
                sortPopular: 'Сначала популярные',
                sortOldest: 'Сначала старые',
                noPublicNotes: 'Пока нет публичных заметок',
                noPublicNotesHint: '{{name}} пока не поделился заметками.',
            },
            noteMenu: {
                makePrivate: 'Сделать приватной',
                makePublic: 'Сделать публичной',
                rename: 'Переименовать',
                createSubnote: 'Создать подзаметку',
                editTags: 'Редактировать теги',
                delete: 'Удалить',
                pin: 'Закрепить',
                unpin: 'Открепить',
                createFolder: 'Создать папку',
                createNote: 'Создать заметку',
                leaveNote: 'Покинуть заметку',
                pinned: 'Заметка закреплена',
                unpinned: 'Заметка откреплена',
                activateEdit: 'Активируйте аккаунт, чтобы редактировать заметки',
                activateCreateFolders: 'Активируйте аккаунт, чтобы создавать папки',
                activateCreateNotes: 'Активируйте аккаунт, чтобы создавать заметки',
                activateDelete: 'Активируйте аккаунт, чтобы удалять заметки',
                leaveNoteConfirm: 'Вы потеряете доступ к "{{title}}". Владелец сможет добавить вас обратно.',
                leftNote: 'Вы покинули заметку',
                activateMakePublic: 'Активируйте аккаунт, чтобы делать заметки публичными',
                madePublic: 'Заметка теперь публичная',
                madePrivate: 'Заметка теперь приватная',
                noteDeleted: 'Заметка удалена',
                deleteConfirmTitle: 'Удалить заметку',
                deleteConfirmMessage:
                    'Вы уверены, что хотите удалить «{{title}}»? Это действие нельзя отменить.',
            },
            share: {
                modalTitle: 'Поделиться «{{title}}»',
                close: 'Закрыть',
                done: 'Готово',
                applyToSubnotes: 'Применить к подзаметкам',
                inviteByEmail: 'Пригласить по email',
                invitePlaceholder: 'Введите email или имя',
                invite: 'Пригласить',
                peopleWithAccess: 'Люди с доступом',
                you: 'Вы',
                userFallback: 'Пользователь {{id}}',
                permission: {
                    view: 'Просмотр',
                    edit: 'Редактирование',
                    viewOnly: 'Только просмотр',
                    viewFull: 'Просмотр',
                    editFull: 'Редактирование',
                },
                link: {
                    title: 'Доступ по ссылке',
                    description: 'Ссылку можно отозвать в любой момент',
                    namePlaceholder: 'Название ссылки (необязательно)',
                    create: 'Создать ссылку',
                    empty: 'Нет активных ссылок',
                    copyTitle: 'Скопировать',
                    revokeTitle: 'Отозвать',
                    expiry: {
                        label: 'Срок действия',
                        never: 'Никогда',
                        oneDay: '1 день',
                        sevenDays: '7 дней',
                        thirtyDays: '30 дней',
                        noExpiry: 'Бессрочно',
                        expired: 'Истекла',
                        expiresToday: 'Истекает сегодня',
                        expiresInDays: 'Истекает через {{count}} д.',
                    },
                },
                toast: {
                    loadAccessFailed: 'Не удалось загрузить список доступа',
                    activateToInvite: 'Активируйте аккаунт, чтобы приглашать пользователей',
                    alreadyHasAccess: 'Пользователь уже имеет доступ',
                    activateToManage: 'Активируйте аккаунт, чтобы управлять доступом',
                    cannotRemoveOwner: 'Нельзя удалить владельца',
                    accessRemoved: 'Доступ удалён',
                    permissionUpdated: 'Права доступа обновлены',
                    linkCreateFailed: 'Не удалось создать ссылку',
                    linkRevoked: 'Ссылка отозвана',
                    linkDeleteFailed: 'Не удалось удалить ссылку',
                    linkCopied: 'Ссылка скопирована',
                    linkCopyFailed: 'Не удалось скопировать',
                    enterEmailOrName: 'Введите email или имя пользователя',
                    userNotFound: 'Пользователь не найден',
                    multipleUsers: 'Найдено несколько пользователей. Уточните запрос.',
                    userIdFailed: 'Не удалось определить ID пользователя',
                    accessGranted: 'Доступ предоставлен {{name}}',
                },
                page: {
                    invalidLink: 'Ссылка недействительна',
                    linkNotFound: 'Ссылка не найдена',
                    loadFailed: 'Не удалось загрузить информацию о ссылке',
                    loading: 'Загрузка...',
                    expiredTitle: 'Ссылка истекла',
                    expiredDescription:
                        'Срок действия этой ссылки закончился. Попросите владельца создать новую.',
                    invalidDescription: 'Эта ссылка не существует или была отозвана.',
                    validUntil: 'До {{date}}',
                    guestEditHint:
                        'Можете просматривать без регистрации. Чтобы редактировать — войдите в аккаунт.',
                    openReadOnly: 'Открыть (только чтение)',
                    loginToEdit: 'Войти для редактирования',
                    guestReadHint: 'Вы можете просматривать эту заметку без регистрации.',
                    openHint: 'Нажмите кнопку ниже, чтобы открыть заметку.',
                    openNote: 'Открыть заметку',
                },
            },
            tags: {
                addTags: 'Добавить теги...',
                removeTag: 'Удалить тег',
                createTag: 'Создать "{{tag}}"',
                filterByTag: 'Фильтр по #{{tag}}',
                blockPublicNote: 'Заблокировать эту публичную заметку',
                noContentYet: 'Пока нет содержимого',
            },
            moderator: {
                noteBlocked: 'Заметка заблокирована',
                failedToBlockNote: 'Не удалось заблокировать заметку',
                blockPublicNoteTitle: 'Заблокировать публичную заметку?',
                blockPublicNoteMessage:
                    'Вы уверены, что хотите заблокировать "{{title}}"?\n\nЗаметка станет приватной и будет скрыта из публичного доступа.',
                block: 'Блокировать',
            },
        },
    },
} as const;

export type AppLanguage = keyof typeof resources;
